export default __webpack_public_path__ + "static/media/head-panda.1450ebd5.png";